"use client"

import { Fragment, type ReactElement } from "react"

import { Popover, PopoverButton, PopoverPanel, Transition } from "@headlessui/react"

import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { getTraderMenuLinks } from "@modules/trader-menu/lib/trader-menu-view-model"

// Story 10.7 — dropdown desktop "Menu do Trader". Só aparece ≥768px (o Nav renderiza-o no bloco
// `hidden md:flex`); no mobile os mesmos links vão no hambúrguer (side-menu). Fonte única: o
// view-model — nada de lista à mão. O Headless UI `Popover` dá a11y de teclado grátis (Esc fecha,
// foco preso, clique fora fecha); `onClick={close}` fecha o painel ao navegar.

export default function TraderMenuNav(): ReactElement {
  const links = getTraderMenuLinks()

  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          {/* Alvo ≥44px (min-h-11); estilo casa com os links do Nav (text-white/60 → white).
              SEM `focus:outline-none`: era o único acesso a abrir o dropdown e a regra da casa
              (`globals.css:13` "Nunca remover outline sem substituto visível") exige foco visível —
              o `:focus-visible` global (outline accent) fica a valer no acesso por teclado. */}
          <PopoverButton
            data-testid="trader-menu-nav-button"
            className="flex min-h-11 items-center gap-x-1 text-sm font-medium text-white/60 transition-colors hover:text-white"
          >
            Menu do Trader
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
              className={`transition-transform duration-200 ${
                open ? "rotate-180" : ""
              }`}
            >
              <path
                d="M6 9l6 6 6-6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </PopoverButton>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-150"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <PopoverPanel className="absolute left-0 top-full z-50 mt-2 w-64 rounded-large border border-border bg-surface p-2 shadow-[0_8px_32px_rgba(0,0,0,0.5)] backdrop-blur-xl">
              <ul className="flex flex-col">
                {links.map((link) => (
                  <li key={link.key}>
                    <LocalizedClientLink
                      href={link.href}
                      onClick={close}
                      data-testid={`trader-menu-nav-${link.key}`}
                      className="flex min-h-11 items-center rounded-[8px] px-3 text-sm text-text transition-colors hover:bg-white/[0.05] hover:text-accent"
                    >
                      {link.label}
                    </LocalizedClientLink>
                  </li>
                ))}
              </ul>
            </PopoverPanel>
          </Transition>
        </>
      )}
    </Popover>
  )
}
